import React from "react";
import "../Usuarios/usuarios.css";
import { SubSections } from "../../data/navItem";
import AsociadosCatalogo from "./AsociadosCatalogo";
import AsociadosDashboard from "./AsociadosDashboard";

export default function Asociados({ subSectionId }) {
  return (
    <div className="recent-sales overflow-auto">
      {subSectionId === SubSections.Dashboard && <AsociadosDashboard />}
      {subSectionId === SubSections.Catalogo && <AsociadosCatalogo />}
    </div>
  );
}
